var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoFavourite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 325.1 262.8",
    style: {
      enableBackground: "new 0 0 325.1 262.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F2F2F2;}\n\t.st1{fill:none;stroke:#BABABA;stroke-width:2.6621;stroke-linecap:round;stroke-linejoin:round;}\n\t.st2{fill:#CFCFCF;}\n\t.st3{fill:#D2D2D2;}\n\t.st4{fill:#FFFFFF;stroke:#BABABA;stroke-width:2.6621;stroke-linecap:round;stroke-linejoin:round;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M217,76.4c-22.3,0-44.9-0.9-66.1-6.8c-21.2-5.9-39.8-17-56.9-29.9c-11.1-8.4-21.3-15.1-35.7-14.1 c-14.1,0.7-27.7,6-38.6,15.1c-18.4,16-15.6,45.9-8.3,66.8c11,31.5,44.7,53.5,73.4,67.7c33,16.5,69.2,26.1,105.7,31.6 c31.9,4.8,72.9,8.4,100.5-12.5c25.4-19.1,32.4-62.8,26.1-92.3c-1.6-8.7-6.3-16.5-13.2-22c-17.8-13-44.4-4.3-64.4-3.9 C232.2,76.2,224.6,76.4,217,76.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M280.1,194.6v11.4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M274.4,200.3h11.4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M80.8,38.8v11.4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M75.1,44.5h11.4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M272.5,39.9c1.4,0,2.6-1.2,2.6-2.6c0-1.4-1.2-2.6-2.6-2.6c-1.4,0-2.6,1.2-2.6,2.6 C269.9,38.7,271,39.9,272.5,39.9z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M89.7,123.3c1.4,0,2.6-1.2,2.6-2.6c0-1.4-1.2-2.6-2.6-2.6s-2.6,1.2-2.6,2.6C87.1,122.1,88.3,123.3,89.7,123.3z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M173.7,258.5c53.9,0,97.6-2.7,97.6-6.1c0-3.4-43.7-6.1-97.6-6.1c-53.9,0-97.6,2.7-97.6,6.1 C76.2,255.8,119.9,258.5,173.7,258.5z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M217.1,196.8l-47.4-28.4c-1.6-1-3.4-1.5-5.3-1.5c-1.9,0-3.7,0.5-5.3,1.5l-46.3,28.2c-1.6,1-3.4,1.5-5.2,1.5 c-1.8,0-3.7-0.4-5.3-1.3c-1.6-0.9-2.9-2.2-3.9-3.8c-0.9-1.6-1.4-3.4-1.4-5.2V18.1c0-2.8,1.1-5.4,3-7.3c1.9-1.9,4.6-3,7.3-3h115.1 c2.8,0,5.4,1.1,7.3,3c1.9,1.9,3,4.6,3,7.3v169.7c0,1.9-0.5,3.7-1.4,5.3c-0.9,1.6-2.3,2.9-3.9,3.8c-1.6,0.9-3.5,1.4-5.3,1.3 C220.5,198.3,218.6,197.7,217.1,196.8z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M237.3,217.5l-49.4-29.7c-1.7-1-3.6-1.6-5.6-1.6c-2,0-3.9,0.5-5.6,1.6l-48.3,29.5c-1.6,1-3.5,1.5-5.5,1.6 c-1.9,0-3.8-0.4-5.5-1.4c-1.7-0.9-3.1-2.3-4.1-4c-1-1.7-1.5-3.6-1.5-5.5V31c0-2.9,1.2-5.6,3.2-7.7c2-2,4.8-3.2,7.7-3.2h120.2 c2.9,0,5.6,1.1,7.7,3.2s3.2,4.8,3.2,7.7v177.2c0,1.9-0.5,3.8-1.5,5.5c-1,1.7-2.4,3-4,4c-1.7,0.9-3.6,1.4-5.5,1.4 C240.8,219,238.9,218.5,237.3,217.5z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M182.7,144c27.5,0,49.8-22.3,49.8-49.8s-22.3-49.8-49.8-49.8s-49.8,22.3-49.8,49.8S155.2,144,182.7,144z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M185.3,59.1l9.2,18.6l20.4,3c0.5,0.1,1,0.3,1.4,0.6c0.4,0.3,0.7,0.8,0.9,1.3c0.2,0.5,0.2,1,0.1,1.6 c-0.1,0.5-0.4,1-0.8,1.4L201.7,100l3.5,20.4c0.1,0.5,0,1.1-0.2,1.6c-0.2,0.5-0.5,0.9-1,1.2c-0.4,0.3-0.9,0.5-1.5,0.5 c-0.5,0-1.1-0.1-1.5-0.3l-18.3-9.7l-18.3,9.6c-0.5,0.2-1,0.4-1.5,0.3c-0.5,0-1-0.2-1.5-0.5c-0.4-0.3-0.8-0.7-1-1.2 c-0.2-0.5-0.3-1-0.2-1.6l3.5-20.4L149,85.4c-0.4-0.4-0.7-0.8-0.8-1.4c-0.1-0.5-0.1-1.1,0.1-1.6c0.2-0.5,0.5-1,0.9-1.3 c0.4-0.3,0.9-0.6,1.4-0.6l20.4-3l9.2-18.6c0.3-0.5,0.6-0.8,1.1-1.1c0.5-0.3,1-0.4,1.5-0.4c0.5,0,1,0.2,1.5,0.5 C184.7,58.2,185.1,58.6,185.3,59.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoFavourite);
export default __webpack_public_path__ + "static/media/no-favourite.942d4caf1c45a3c3eba6c706d08c575a.svg";
export { ForwardRef as ReactComponent };